import { createApi } from '@reduxjs/toolkit/query/react';
import {
  TGetDBCVersionsQuery,
  TGetDBCVersionsResponse,
  TGetTierGearBuSlotQuery,
  TGetTierTalentsQuery,
  TGetTierTrinketsQuery,
  TTierGearBySlotResponse,
  TTierTalentsResponse,
  TTierTrinketsResponse
} from '../../../../../../shared/types/statisticsTypes';
import { TLoadoutCompareRequest, TLoadoutCompareResponse } from '../../../../../../shared/types/talentCompareTypes';
import { networkBaseQuery } from '../../services/api/utils';

export const specStatisticsApi = createApi({
  reducerPath: 'specStatisticsApi',
  baseQuery: networkBaseQuery,
  endpoints: (builder) => ({
    getTierTalentsData: builder.query<TTierTalentsResponse, TGetTierTalentsQuery>({
      query: (params) => ({ url: '/api/statistics/tier/talents', params })
    }),
    getTierGearData: builder.query<TTierGearBySlotResponse, TGetTierGearBuSlotQuery>({
      query: (params) => ({ url: '/api/statistics/tier/gear', params })
    }),
    getTierTrinketsData: builder.query<TTierTrinketsResponse, TGetTierTrinketsQuery>({
      query: (params) => ({ url: '/api/statistics/tier/trinkets', params })
    }),
    compareTalentLoadoutsRuntime: builder.query<TLoadoutCompareResponse, TLoadoutCompareRequest>({
      query: (params) => ({ url: '/api/talents/compare-runtime', params })
    }),
    getDBCVersions: builder.query<TGetDBCVersionsResponse, TGetDBCVersionsQuery | void>({
      query: (params) => ({ url: '/api/statistics/dbc-versions', params: params ?? {} }),
      keepUnusedDataFor: Number.POSITIVE_INFINITY
    })
  })
});

export const {
  useGetTierTalentsDataQuery,
  useGetTierGearDataQuery,
  useGetTierTrinketsDataQuery,
  useCompareTalentLoadoutsRuntimeQuery,
  useLazyCompareTalentLoadoutsRuntimeQuery,
  useGetDBCVersionsQuery
} = specStatisticsApi;
